import AirTabbedModal from './AirTabbedModal';
export default AirTabbedModal;



// WEBPACK FOOTER //
// ./src/common/components/AirTabbedModal/index.js